// @ts-strict-ignore
import {Component, Input, OnInit} from "@angular/core";
import {DisplayMode, Permissions} from "@models";
import {EventEmitterService} from "@event-emitter";
import {CameraLayoutOptionsContainer} from "../../../../types/camera-layout-options";
import {BaseRecorderLayout} from "../base-recorder-layout";

@Component({
	selector: "sim-recorder-layout-bss",
	templateUrl: "./recorder-layout-bss.component.html",
	styleUrls: ["./recorder-layout-bss.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class RecorderLayoutBssComponent extends BaseRecorderLayout implements OnInit {
	@Input() cameraLayoutOptionsContainer: CameraLayoutOptionsContainer;

	constructor(private _emitterService: EventEmitterService) {
		super();
	}

	ngOnInit() {}
}
